import React, { Suspense, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { GraduationCap, Download } from "lucide-react";

const Spline = React.lazy(() => import("@splinetool/react-spline"));

const Hero = ({ onRegister }) => {
  const navigate = useNavigate();
  
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section
      id="hero"
      style={{
        minHeight: "100vh",
        background: "#000",
        paddingTop: isMobile ? "100px" : "96px",
        display: "flex",
        alignItems: "center",
        overflowX: "hidden",
      }}
    >
      <div
        style={{
          width: "100%",
          paddingLeft: isMobile ? "5%" : "6%",
          paddingRight: isMobile ? "5%" : "6%",
          paddingBottom: "40px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            gap: isMobile ? "20px" : "80px",
          }}
        >
          {/* ================= LEFT CONTENT ================= */}
          <div style={{ 
            maxWidth: isMobile ? "100%" : "680px", 
            textAlign: isMobile ? "center" : "left",
            flex: "1.1" 
          }}>
            {/* Audience Badge */}
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
                padding: "8px 16px",
                borderRadius: "999px",
                background: "rgba(0,255,255,0.1)",
                marginBottom: "24px",
                fontSize: isMobile ? "12px" : "13px",
                color: "#3fffe0",
                fontWeight: "600"
              }}
            >
              <GraduationCap size={16} />
              For Students • Freshers • Professionals
            </div>

            {/* Headline */}
            <h1
              style={{
                fontSize: isMobile ? "36px" : "56px", 
                lineHeight: "1.2",
                fontWeight: 800,
                marginBottom: "20px",
                color: "#fff"
              }}
            >
              Become Job-Ready in <br />
              <span style={{ color: "#3fffe0" }}>
                Cybersecurity, Networking, Cloud & Web Development
              </span>
            </h1>

            {/* 🔥 REWRITTEN HIGH-IMPACT DESCRIPTION FOR SEO RANKING */}
            <p
              style={{
                fontSize: isMobile ? "16px" : "18px",
                lineHeight: "1.6",
                color: "#cbd5e1",
                marginBottom: "32px",
                maxWidth: "600px",
                marginLeft: isMobile ? "auto" : "0",
                marginRight: isMobile ? "auto" : "0",
              }}
            >
              Best Ethical Hacking, Cybersecurity & AIML Training Institute in Indore with Live SOC Labs. Get certified in VAPT, Python systems engineering, and enterprise cloud operations at our Vijay Nagar center to kickstart your career in <strong>3–10 months</strong>.
            </p>

            {/* 🔥 KEYWORD-DENSE BULLET POINTS */}
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                marginBottom: "40px",
                display: "grid",
                justifyContent: isMobile ? "center" : "start",
                gap: "12px",
                color: "#e5e7eb",
                fontSize: "15px",
                textAlign: "left",
              }}
            >
              <li>✔ Best Cyber Security Institute in Indore with real SOC sandboxes</li>
              <li>✔ Production-ready Python and AIML framework engineering modules</li>
              <li>✔ Guaranteed corporate internship track with Ciqur24 Bengaluru HQ</li>
            </ul>

            {/* CTAs */}
            <div style={{ 
              display: "flex", 
              gap: "15px", 
              flexDirection: isMobile ? "column" : "row",
              width: isMobile ? "100%" : "auto"
            }}>
              <Button 
                className="btn-primary"  
                style={{ width: isMobile ? "100%" : "auto", height: "50px" }}
                onClick={() => window.open('https://forms.office.com/Pages/ResponsePage.aspx?id=GIlUwqulxkW2gUlR5VePC12nZ4fz5yRFkrQsWYzu1nBUN01NTlFFS0lQOFhRNjk4MDVaQloxTkJBRS4u', '_blank', 'noopener,noreferrer')}
              >
                Register Now 
              </Button>

              <Button
                className="btn-secondary"
                style={{ width: isMobile ? "100%" : "auto", height: "50px" }}
                onClick={() => navigate("/programs")}
              >
                <Download size={18} />
                Curriculum
              </Button>
            </div>
          </div>

          {/* ================= RIGHT VISUAL (3D Environment Animation) ================= */}
          {!isMobile && (
            <div
              style={{
                width: "100%",
                height: "640px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flex: "0.9",
              }}
            >
              <Suspense
                fallback={
                  <div style={{ color: "#6b7280", fontSize: "14px" }}>
                    Loading interactive environment…
                  </div>
                }
              >
                <div style={{ width: "100%", height: "100%" }}>
                  <Spline scene="https://prod.spline.design/NbVmy6DPLhY-5Lvg/scene.splinecode" />
                </div>
              </Suspense>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Hero;